import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg'
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icon/magic.svg'
import gImg1 from '../../images/gallery/c1.png'
import gImg2 from '../../images/gallery/c2.png'
import gImg3 from '../../images/gallery/c3.png'
import gImg4 from '../../images/gallery/c4.png'
import gImg5 from '../../images/gallery/c5.png'
import gImg6 from '../../images/gallery/c6.png'

const TermsPage = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />
                <section className="page-title cp-page-title pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">

                                {/* HEADER TITLE UPDATED */}
                                <div className="col-lg-8 mt-30">
                                    <div className="page-title-box">
                                        <span className="sub-title"><img src={icon} alt="" />Terms & Conditions</span>
                                        <h2 className="title">
                                            Uniflame website terms & <br /> conditions your access and <br /> usage rights
                                        </h2>
                                    
                                    </div>
                                </div>

                                <div className="col-lg-4 mt-30">
                                    <div className="cp-img-slide">
                                        <div className="cp-img-inner ul_li">
                                            <div className="cp-item marquee-first">
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                            </div>
                                            <div className="cp-item marquee-2">
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                {/* ------- TERMS CONTENT UPDATED ------- */}

                <section className="terms&conditions-section cp-det-bg">
                    <div className="container">
                        <div className="terms-section_inner pt-120 pb-75">
                            <div className="row">
                                <div className="col-lg-11">

                                    {/* INTELLECTUAL PROPERTY */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Copyright and intellectual property usage</h2>

                                        <p>
                                            All content on this website, including text, graphics, logos, code assets, and branding,
                                            is the intellectual property of Uniflame and is protected by copyright and trademark laws.
                                            Unauthorized reproduction, modification or distribution of any content may result in legal
                                            action. Uniflame is not responsible for third-party brand logos shown on the website;
                                            ownership of those remains with their respective companies.
                                        </p>

                                        <p>
                                            Some images may include licensed stock assets for visual purposes. Uniflame does not claim
                                            copyright on such stock items. All other names, graphics, or marks belong to their rightful
                                            owners.
                                        </p>
                                    </div>

                                    {/* WEBSITE USAGE TERMS */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Website usage terms</h2>

                                        <p>
                                            By visiting this website, you agree not to copy, alter, distribute, or publish any content
                                            from the site—including text, graphics, videos, or documents—without written permission.
                                            Uniflame reserves all rights not explicitly granted here.
                                        </p>

                                        <p>
                                            You also agree not to upload or send unlawful, offensive, misleading, or harmful material
                                            through any contact forms or communication channels. Website contact details should never
                                            be used for unsolicited marketing or promotional messaging.
                                        </p>

                                        <p>
                                            This website may contain external links for reference. Uniflame is not responsible for the
                                            accuracy, policies, or content of any third-party website. Accessing external sites is done
                                            at your own risk.
                                        </p>
                                    </div>

                                    {/* SOFTWARE & SERVICES */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Software and services</h2>
                                        <p>
                                            All software, integrations, ERP implementations, or digital services offered by Uniflame
                                            are governed by separate service agreements. These terms must be accepted before project
                                            initiation. Services are provided on an “as-is” and “as-available” basis unless otherwise
                                            stated in the signed agreement.
                                        </p>
                                    </div>

                                    {/* PERSONAL INFORMATION */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Personal information policy</h2>
                                        <p>
                                            Uniflame follows strict ethical practices and protects your personal information in line
                                            with our Privacy Policy. We recommend reviewing the Privacy Policy for detailed information
                                            on data handling and protection.
                                        </p>
                                    </div>

                                    {/* DISCLAIMER */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Disclaimer</h2>

                                        <p>
                                            The information provided on this website is intended for general purposes and may include
                                            inaccuracies or typographical errors. Although Uniflame attempts to ensure accuracy,
                                            the company does not make any explicit or implied warranties regarding the information,
                                            products, or services displayed on the site.
                                        </p>

                                        <p>
                                            Uniflame is not liable for any damages—including financial loss, downtime, or data loss—
                                            resulting from the use of this website or reliance on its content. Users agree to indemnify
                                            Uniflame from any claims arising from improper use of website materials or services.
                                        </p>
                                    </div>

                                    {/* LIABILITY LIMITATION */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Limitation of liability</h2>
                                        <p>
                                            Uniflame shall not be held responsible for any direct or indirect damages, including loss
                                            of data or revenue, even if prior notice was given. Some jurisdictions do not allow limitation
                                            of liability, so this may not apply in certain regions.
                                        </p>
                                    </div>

                                    {/* CONTACT */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Contact</h2>
                                        <p>
                                            <Link onClick={ClickHandler} to="/contact" className="details-link">Click here</Link> 
                                            to contact us regarding Terms & Conditions or any other inquiries. You can also reach us at:
                                            <br />
                                            <a href="mailto:support@uniflame.org">support@uniflame.org</a>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <CtaSection cClass={'bg'} />
            </div>

            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default TermsPage;
